const ImageGalleryModal = ({ destinationImages, tripSummary, galleryIndex, setGalleryIndex, onClose }) => {
  return (
    <div className="fixed inset-0 z-[100] bg-black flex flex-col">
      <div className="flex items-center justify-between px-6 py-4 bg-black/80">
        <div className="flex items-center gap-4">
          <span className="text-white font-medium">{tripSummary?.destination} Photos</span>
          <span className="text-white/60 text-sm">{galleryIndex + 1} of {destinationImages.length}</span>
        </div>
        <button
          onClick={onClose}
          className="text-white/80 hover:text-white p-2 hover:bg-white/10 rounded-full transition-colors cursor-pointer"
          title="Close (Esc)"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="flex-1 flex items-center justify-center relative px-4">
        <button
          onClick={() => setGalleryIndex(prev => (prev > 0 ? prev - 1 : destinationImages.length - 1))}
          className="absolute left-4 lg:left-8 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors cursor-pointer"
          title="Previous (←)"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <div className="max-w-4xl w-full mx-auto px-16">
          <img
            src={destinationImages[galleryIndex]?.url}
            alt={destinationImages[galleryIndex]?.alt || 'Travel photo'}
            className="w-full max-h-[65vh] object-contain rounded-lg shadow-2xl"
          />
        </div>

        <button
          onClick={() => setGalleryIndex(prev => (prev < destinationImages.length - 1 ? prev + 1 : 0))}
          className="absolute right-4 lg:right-8 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors cursor-pointer"
          title="Next (→)"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>



      <div className="bg-black/80 py-4 px-4">
        <div className="flex justify-center gap-2 overflow-x-auto max-w-4xl mx-auto">
          {destinationImages.map((img, idx) => (
            <button
              key={idx}
              onClick={() => setGalleryIndex(idx)}
              className={`w-16 h-12 rounded-lg overflow-hidden flex-shrink-0 transition-all cursor-pointer ${
                galleryIndex === idx
                  ? 'ring-2 ring-white scale-105'
                  : 'opacity-40 hover:opacity-80'
              }`}
            >
              <img src={img.thumb || img.small || img.url} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      </div>

      <div className="text-center py-2 bg-black/80">
        <p className="text-white/30 text-xs">Use ← → arrows to navigate • Esc to close</p>
      </div>
    </div>
  );
};

export default ImageGalleryModal;
